/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  userServiceAPIUrl: 'https://account.reidin.com',
  geoserverUrl: 'https://retailprodgeoserver.reidin.com',
  backendAPIUrl: 'https://insight-api.reidin.com',
  contentAPIUrl: 'https://mapapiretail.reidin.com',
  reidimapUrl: 'https://map.reidin.com',
  clientSecret:
    'aW5zaWdodDpweFpmZXVFWm5keUIyOVBqaHpwY1VVeEZVV205NEFtUXJVQXN4YlVma01HWTNiNWhNQWNtQW1mZQ==',
  powerBIRestAPIUrl: 'https://api.powerbi.com/v1.0/myorg/',
  googleAnalyticsKey: 'UA-152830740-3',
  hmr: false,
  atatusKey: 'baa6ffa23e614ada857227857164e704'
};